<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
          <v-row dense>
            <v-col class="ma-0 pa-0 text-center">
              <label class="font-weight-bold blue--text text--darken-4 title">Wing Mission Alerting Operator Module</label>

                <div v-if="current_wmao_record.capid == usercapid" class="mt-5">
                  <v-btn color="red lighten-4" height="50" rounded shaped class="red--text text--darken-4 font-weight-bold subtitle-1" dark width="200" @click="alertICs();">Alert ICs</v-btn>
                </div>
                <div v-else class="mt-5">
                  <v-btn color="green lighten-4" height="50" rounded shaped class="pl-5 pr-5 green--text text--darken-4 font-weight-bold subtitle-1" dark width="200" @click="showPhoneModal=true">Assume WMAO Duty</v-btn>
                </div>
                <div v-if="current_wmao_record.capid == '' ||  current_wmao_record.capid == null || current_wmao_record.capid == undefined" class="mt-5">
                  <label class="font-weight-bold red--text text--darken-3 title">WARNING!!<br />NO WMAO ON DUTY</label>
                </div>
                <br /><br />
            </v-col>
          </v-row>
          <div v-if="current_wmao_record.capid != '' && current_wmao_record.capid != null && current_wmao_record.capid != undefined">
            <v-row class="ma-0 pa-0 mb-2">
              <v-col v-if="current_wmao_record.capid != usercapid" dense class="blue darken-2 text-center">
                <label class="font-weight-bold white--text subtitle-1">{{ current_wmao_record.capid == usercapid ? 'You are the Current WMAO' : 'Current WMAO' }}</label>
              </v-col>
              <v-col v-else dense class="orange lighten-3 text-center">
                <label class="font-weight-bold black--text subtitle-1">{{ current_wmao_record.capid == usercapid ? 'You are the Current WMAO' : 'Current WMAO' }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="blue--text text--darken-4 font-weight-bold subtitle-1">{{ current_wmao_record.membername }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="font-weight-bold subtitle-1">{{ current_wmao_record.unitname }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="subtitle-1"><span class="font-weight-bold">Forwarding: </span>{{ current_wmao_record.alertphone }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="subtitle-1"><span class="font-weight-bold">Shift Started: </span>{{ getLocaltime(current_wmao_record.startdatetime) }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="subtitle-1"><span class="font-weight-bold">Hrs On Duty: </span>{{ shiftHours(this.$moment().utc(), this.$moment(current_wmao_record.startdatetime))}}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="mb-5 ma-0 pa-0 mt-4">
              <v-col class="text-center">
                <v-btn v-if="current_wmao_record.homephone != ''" class="mr-3" fab dark small  color="blue darken-4" :href="`tel:+1${current_wmao_record.homephone}`">
                  <v-icon small dark>mdi-phone</v-icon>
                </v-btn>
                <v-btn v-if="current_wmao_record.cellphone != ''" fab dark small color="green darken-4" :href="`tel:+1${current_wmao_record.cellphone}`">
                  <v-icon small dark>mdi-cellphone</v-icon>
                </v-btn>
                <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${current_wmao_record.email}`">
                  <v-icon dark>mdi-email</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0 mb-2">
              <v-col v-if="current_wmao_record.capid != usercapid" dense class="blue darken-2 text-center">
                <label class="font-weight-bold white--text subtitle-1">{{ current_wmao_record.capid == usercapid ? 'Your WMAO Coordinators' : 'WMAO Coordinators' }}</label>
              </v-col>
              <v-col v-else dense class="orange lighten-3 text-center">
                <label class="font-weight-bold black--text subtitle-1">{{ current_wmao_record.capid == usercapid ? 'Your WMAO Coordinators' : 'WMAO Coordinators' }}</label>
              </v-col>
            </v-row>


            <div v-for="(item, index) in coordinators" :key="index">
              <v-row dense no-gutters class="ma-0 pa-0">
                <v-col class="text-center">
                  <label class="blue--text text--darken-4 font-weight-bold subtitle-1">{{ item.membername }} ({{ item.capid }})</label>
                </v-col>
              </v-row>
              <v-row dense no-gutters class="ma-0 pa-0">
                <v-col class="text-center">
                  <label class="font-weight-bold subtitle-1">{{ item.unitname }}</label>
                </v-col>
              </v-row>
              <v-row dense no-gutters class="ma-0 pa-0 mt-4 mb-4">
                <v-col class="text-center">
                  <v-btn v-if="item.homephone != ''" class="mr-3" fab dark small color="blue darken-4" :href="`tel:+1${item.homephone}`">
                    <v-icon small dark>mdi-phone</v-icon>
                  </v-btn>
                  <v-btn v-if="item.cellphone != ''" fab dark small color="green darken-4" :href="`tel:+1${item.cellphone}`">
                    <v-icon small dark>mdi-cellphone</v-icon>
                  </v-btn>
                  <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${item.email}`">
                    <v-icon dark>mdi-email</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense no-gutters class="ma-0 pa-0">
                <v-col class="text-center">
                  <hr />
                </v-col>
              </v-row>
            </div>

            <v-row class="mt-4 mb-2 ma-0 pa-0">
              <v-col dense class="blue darken-2 text-center">
                <label class="font-weight-bold white--text subtitle-1">Previous WMAO</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="blue--text text--darken-4 font-weight-bold subtitle-1">{{ previous_wmao_record.membername }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="font-weight-bold subtitle-1">{{ previous_wmao_record.unitname }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="subtitle-1"><span class="font-weight-bold">Shift Started: </span>{{ getLocaltime(previous_wmao_record.startdatetime) }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="subtitle-1"><span class="font-weight-bold">Shift Ended: </span>{{ getLocaltime(previous_wmao_record.enddatetime) }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0">
              <v-col class="text-center">
                <label class="subtitle-1"><span class="font-weight-bold">Shift Length (hrs): </span>{{ shiftHours(this.$moment(previous_wmao_record.enddatetime),this.$moment(previous_wmao_record.startdatetime)) }}</label>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="ma-0 pa-0 mt-4">
              <v-col class="text-center">
                <v-btn v-if="previous_wmao_record.homephone != ''" class="mr-3" fab dark small  color="blue darken-4" :href="`tel:+1${previous_wmao_record.homephone}`">
                  <v-icon small dark>mdi-phone</v-icon>
                </v-btn>
                <v-btn v-if="previous_wmao_record.cellphone != ''" fab dark small color="green darken-4" :href="`tel:+1${previous_wmao_record.cellphone}`">
                  <v-icon small dark>mdi-cellphone</v-icon>
                </v-btn>
                <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${previous_wmao_record.email}`">
                  <v-icon dark>mdi-email</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
    </div>

    <!-- Begin - Select Phone Number Modal -->
    <v-dialog
      v-model="showPhoneModal"
      persistent
      width="300"
    >
      <v-card
        outlined
        light
      >
        <v-card-title>
          <label class="blue--text text--darken-4 text-center title">Select Forwarding Number</label>
        </v-card-title>
        <v-card-text class="text-center">
          <div v-if="myPhoneNumbers.length > 0">
            <span class="red--text pb-2 font-weight-black">** NOTE **</span><br /><span class="red--text font-weight-black">Make sure you select the correct number, you will not be able to reselect another number once you confirm this selection.</span><br />
            <br />
            <div  v-for="(num, index) in myPhoneNumbers" :key="index" class="text-center">
              <v-btn class="mb-2" fab light medium color="blue darken-4" @click="forwardPhone=num.phone;showPhoneModal=false;showConfirmModal=true">
                  <v-icon medium dark class="white--text">mdi-phone-incoming-outline</v-icon>
              </v-btn>
              <span class="blue--text text--darken-4 font-weight-bold pl-5 subtitle-1">{{num.alertphone}}</span>
            </div>
          </div>
          <div v-else>
            <span class="red--text font-weight-black">You currently have NO useable phone numbers in E-Services.  You cannot be the Wing Mission Alerting Officer.  Please add a valid home or cell phone number to E-Services and wait 24 hours.</span>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center">
            <v-btn color="blue darken-4" class="white--text" @click="showPhoneModal=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

    <!-- Begin - Confirm Modal -->
    <v-dialog
      v-model="showConfirmModal"
      persistent
      width="300"
    >
      <v-card
        outlined
        light
        color="red"
      >
        <v-card-title class="justify-center text-center">
          <label class="white--text text--darken-4 text-center title">Confirm WMAO Duty</label>
        </v-card-title>
        <v-card-text class="text-center">

          <label class="white--text text-center">Click the 'CONFIRM' button, if you are sure you want to assume WMAO duty forwarding to {{formatPhoneNumber(forwardPhone)}}?<br /><br />YOU CANNOT UNDO ONCE CONFIRMED!</label>
        </v-card-text>

        <v-card-actions class="justify-center">
            <v-btn color="red darken-4" class="white--text" @click="setMyselfAsWMAO()">Confirm</v-btn>
            <v-btn color="red darken-4" class="white--text" @click="showConfirmModal=false;showPhoneModal=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

    <!-- Begin - Confirm Modal -->
    <v-dialog
      v-model="showConfirmWaitModal"
      persistent
      width="300"
    >
      <v-card
        outlined
        light
        color="blue darken-4"
      >
        <v-card-title class="justify-center text-center">
          <label class="white--text text--darken-4 text-center title">Wait for Alert System</label>
        </v-card-title>
        <v-card-text class="text-center">

          <label class="white--text text-center">Please wait while the alert system contacts you.  This may take a few minutes, you can click the Close button below at any time.</label>
        </v-card-text>

        <v-card-actions class="justify-center">
            <v-btn color="blue lighten-4" class="blue--text text--darken-4" @click="showConfirmWaitModal=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>      
</template>

<script>

  export default {
    timers: {
      getCurrentWMAO: { time: 5000, autostart: false, repeat: true, immediate: true }
    },
    name: 'WMAO',
    data () {
      return {
        search: '',
        showPhoneModal: false,
        showConfirmModal: false,
        showConfirmWaitModal: false,
        showMain: true,
        current_wmao_record: {
          capid: '',
          phone: '',
          displayphone: '',
          alertphone: '',
          membername: '',
          unitname: '',
          startdatetime: ''
        },
        previous_wmao_record: {
          capid: '',
          phone: '',
          displayphone: '',
          alertphone: '',
          membername: '',
          unitname: '',
          startdatetime: '',
          enddatetime:''
        },
        httpResponse:'',
        coordinators:[
          {
            capid:'',
            level:'',
            orgid:null,
            unitname: '',
            membername: '',
            email: '',
            cellphone: '',
            homephone: ''
          }
        ],
        myPhoneNumbers:[],
        forwardPhone:''
      }
    },
    mounted() {
      this.setBackButtonVisibility(false);
      this.setHomeButtonVisibility(true);
      this.getPhoneMyPhoneNumbers(this.usercapid);
      this.startDataLoop();
    },
    destroyed() {
      this.$timer.stop('getCurrentWMAO')
    },
    methods: {
      startDataLoop() {
        this.$timer.start('getCurrentWMAO')
      },
      getCurrentWMAO() {

        if(this.loggedIn == true){
          var obj = {
            wing: this.selWing
          }

          this.$https.post(this.$vars.BaseUrl + this.$vars.GetCurrentWMAORecordRoute, obj, this.$vars.config)
            .then(response => {
              //console.log(response);
              this.httpResponse = response;
              this.current_wmao_record = response.data;

              if(this.current_wmao_record.capid != "" && this.current_wmao_record.capid != null && this.current_wmao_record.capid != undefined)
              {
                this.getWMAOCoordinators(this.current_wmao_record.capid);
                this.getPreviousWMAO();
              }


            })
            .catch(e => {
              console.log(e);
            });
        }
      },
      getPreviousWMAO() {

        if(this.loggedIn == true){

          var obj = {
            wing: this.selWing
          }
          //console.log(obj)
          this.$https.post(this.$vars.BaseUrl + this.$vars.getPreviousWMAORecordRoute, obj, this.$vars.config)
            .then(response => {
              //console.log(response);
              this.httpResponse = response;
              this.previous_wmao_record = response.data;
            })
            .catch(e => {
              console.log(e);
            });
        }
      },
      getWMAOCoordinators(localcapid) {

        //var localcapid = '594385'

        var obj = {
          wing: this.selWing,
          capid: localcapid
        }

        //console.log(obj)

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetWMAOCoordinatorsbyCapidRoute, obj, this.$vars.config)
          .then(response => {
            //console.log(response);
            this.httpResponse = response;
            this.coordinators = response.data;
          })
          .catch(e => {
            console.log(e);
          });
      },
      getLocaltime(date) {
        //console.log(date.toString() + 'Z')
        if (date != null && date != undefined)
        {
          var localDate = this.$moment(date.toString());
          var returnVal = this.$moment(localDate).format('MM/DD/YYYY HH:mm')
          return returnVal;
        }
      },
      setMyselfAsWMAO() {

        var obj = {
          wing: this.selWing,
          capid: this.usercapid,
          phone: this.forwardPhone,
          source: 'PRMA'
        }

        //console.log(obj)

        this.$https.post(this.$vars.BaseUrl + this.$vars.SetCurrentWMAORoute, obj, this.$vars.config)
          .then(response => {
            //console.log(response);
            this.httpResponse = response;
            this.current_wmao_record = response.data;
            this.getCurrentWMAO();
            this.showPhoneModal=false;
            this.showConfirmModal=false
          })
          .catch(e => {
            console.log(e);
          });
      },
      alertICs() {

        this.showConfirmWaitModal=true;

        this.$https.post(this.$vars.AlertBaseUrl + this.$vars.AlertICWMAORoute, this.$vars.alertconfig)
          .then(response => {
            this.httpResponse = response;

          })
          .catch(e => {
            console.log(e);
          });

      },
      getPhoneMyPhoneNumbers(localcapid) {

        //console.log(JSON.stringify(this.$vars.alertconfig))
        var obj = {
          wing: this.selWing,
          capid: localcapid
        }

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetPhoneNumbersforMemberRoute, obj, this.$vars.config)
          .then(response => {
            //console.log(response);
            this.httpResponse = response;
            this.myPhoneNumbers = response.data;
            //console.log(this.myPhoneNumbers)
          })
          .catch(e => {
            console.log(e);
          });
      },
      shiftHours(dt2, dt1) {
        var localEndDate = dt2;
        var localStartDate = dt1;
        var mins = localEndDate.diff(localStartDate, 'minutes');
        var hours = (mins / 60).toFixed(1)
        return hours
      },
      formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '')
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null
      }
    }
  }
</script>

<style scoped>

</style>
